// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { fermentationProtocolModeEnum } from './FermentationProtocolModeEnum';
import { fermentationGroupId } from './FermentationGroup';
import { z } from 'zod';
export const fermentationProtocolId = (z.number());
export const fermentationProtocol = z.object({
    id: fermentationProtocolId,
    name: z.string().nullable(),
    version: z.string().nullable(),
    description: z.string().nullable(),
    derived_from_id: fermentationProtocolId.nullable(),
    is_locked: z.boolean(),
    owner_operator_id: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    mode: fermentationProtocolModeEnum,
    group_id: fermentationGroupId.nullable(),
    archived_at: z.date().nullable(),
    archived_by: operatorId.nullable(),
});
export const fermentationProtocolInitializer = z.object({
    id: fermentationProtocolId.optional(),
    name: z.string().optional().nullable(),
    version: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    derived_from_id: fermentationProtocolId.optional().nullable(),
    is_locked: z.boolean().optional(),
    owner_operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    mode: fermentationProtocolModeEnum.optional(),
    group_id: fermentationGroupId.optional().nullable(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
});
export const fermentationProtocolMutator = z.object({
    id: fermentationProtocolId.optional(),
    name: z.string().optional().nullable(),
    version: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    derived_from_id: fermentationProtocolId.optional().nullable(),
    is_locked: z.boolean().optional(),
    owner_operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    mode: fermentationProtocolModeEnum.optional(),
    group_id: fermentationGroupId.optional().nullable(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationProtocol.js.map